export default "__VITE_ASSET__Cw5i8agy__"